import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { makeWhiteLabeledTheme, SolvTheme } from '../theme/theme';
import { whiteLabelPalettes } from '../theme/whiteLabelColors';

type Props = {
  children: ReactNode;
};

const SolvThemeProvider = ({ children }: Props) => {
  return <ThemeProvider theme={SolvTheme}>{children}</ThemeProvider>;
};

/**
 * This HOC can be used to wrap components that, given a color palette name from whiteLabelPalettes,
 * will show up with the colors from a custom color palette
 */
export const WhiteLabelThemeProvider = ({
  children,
  theme,
}: {
  children: ReactNode;
  theme: keyof typeof whiteLabelPalettes;
}) => {
  return (
    <ThemeProvider theme={makeWhiteLabeledTheme(theme)}>
      {children}
    </ThemeProvider>
  );
};

SolvThemeProvider.displayName = 'SolvThemeProvider';
export default SolvThemeProvider;
